@if (projectService.currentProject()) {
  <aside class="sidebar" [class.sidebar--collapsed]="collapsed" *appI18nScopeReady>
    <nav class="sidebar__nav">
      <ul class="sidebar__list">

        <!-- Shared markup for a simple (non-group) nav item. -->
        <ng-template #simpleNav let-item="item">
          @let tooltipKey = navItemTooltipKey(item);
          <li
            class="sidebar__item"
            [class.sidebar__item--active]="item.route === activeRoute()"
            [class.disabled]="isNavItemDisabled(item)"
          >
            <a
              [tabindex]="0"
              class="sidebar__link"
              (click)="navigateTo(item, undefined, $event)"
              (auxclick)="navigateTo(item, undefined, $event)"
              (keydown.enter)="navigateTo(item)"
              [matTooltip]="tooltipKey ? (tooltipKey | i18n) : ''"
              matTooltipPosition="right"
            >
              @if (item.symbolIcon) {<span class="sidebar__icon material-symbols-outlined">{{ item.symbolIcon }}</span>}
              @else if (item.icon) {<mat-icon class="sidebar__icon">{{ item.icon }}</mat-icon>}
              <span class="sidebar__label">{{ item.label | i18n }}</span>
              @if (showNotificationDot(item)) {
                <span
                  class="sidebar__notification-dot"
                  [matTooltip]="notificationDotTooltipKey(item) | i18n"
                  matTooltipPosition="right"
                ></span>
              }
            </a>
          </li>
        </ng-template>

        @if (checklistOperateurVisible()) {
          <ng-container *ngTemplateOutlet="simpleNav; context: { item: checklistOperateurNavItem }" />
        }

        <!-- ═══════════ Exploitation - Gestion des flux ═══════════ -->
        @if (exploitationVisible()) {
          @if (!collapsed) {
            <li class="sidebar__section-caption">{{ 'nav_section_exploitation' | i18n }}</li>
          }
          @if (planningVisible()) {
            <ng-container *ngTemplateOutlet="simpleNav; context: { item: planningNavItem }" />
          }
          @if (approvisionnementsVisible()) {
            <ng-container *ngTemplateOutlet="simpleNav; context: { item: approvisionnementsNavItem }" />
          }
          @if (incorporationsVisible()) {
          <li class="sidebar__item sidebar__item--group">
            <a
              [tabindex]="0"
              class="sidebar__link sidebar__link--group"
              (click)="incorporationsExpanded.set(!incorporationsExpanded())"
              (keydown.enter)="incorporationsExpanded.set(!incorporationsExpanded())"
            >
              <mat-icon class="sidebar__icon">{{ incorporationsGroup.icon }}</mat-icon>
              <span class="sidebar__label">{{ incorporationsGroup.label | i18n }}</span>
              @if (!collapsed) {
                <mat-icon class="sidebar__chevron">
                  {{ incorporationsExpanded() ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              }
            </a>
            @if (incorporationsExpanded() && !collapsed) {
              <div class="sidebar__children">
                @for (child of incorporationsGroup.children; track child.route) {
                  @if (isChildVisible(child)) {
                    <div
                      class="sidebar__child"
                      [class.sidebar__child--active]="isChildActive(child)"
                      [tabindex]="0"
                      (click)="navigateToChild(child, $event)"
                      (auxclick)="navigateToChild(child, $event)"
                      (keydown.enter)="navigateToChild(child)"
                    >
                      <span class="dot"></span>
                      <span class="label">{{ child.label | i18n }}</span>
                    </div>
                  }
                }
              </div>
            }
          </li>
          }
          @if (biodecVisible()) {
            <ng-container *ngTemplateOutlet="simpleNav; context: { item: biodecNavItem }" />
          }
          @if (expeditionsVisible()) {
            <ng-container *ngTemplateOutlet="simpleNav; context: { item: expeditionsNavItem }" />
          }
          @if (correctionsVisible()) {
            <ng-container *ngTemplateOutlet="simpleNav; context: { item: correctionsNavItem }" />
          }
          @if (stocksVisible()) {
          <li class="sidebar__item sidebar__item--group">
            <a
              [tabindex]="0"
              class="sidebar__link sidebar__link--group"
              (click)="stocksExpanded.set(!stocksExpanded())"
              (keydown.enter)="stocksExpanded.set(!stocksExpanded())"
            >
              <mat-icon class="sidebar__icon">{{ stocksGroup.icon }}</mat-icon>
              <span class="sidebar__label">{{ stocksGroup.label | i18n }}</span>
              @if (!collapsed) {
                <mat-icon class="sidebar__chevron">
                  {{ stocksExpanded() ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              }
            </a>
            @if (stocksExpanded() && !collapsed) {
              <div class="sidebar__children">
                @for (child of stocksGroup.children; track child.route) {
                  @if (isChildVisible(child)) {
                    <div
                      class="sidebar__child"
                      [class.sidebar__child--active]="isChildActive(child)"
                      [tabindex]="0"
                      (click)="navigateToChild(child, $event)"
                      (auxclick)="navigateToChild(child, $event)"
                      (keydown.enter)="navigateToChild(child)"
                    >
                      <span class="dot"></span>
                      <span class="label">{{ child.label | i18n }}</span>
                    </div>
                  }
                }
              </div>
            }
          </li>
          }
          @if (digestatVisible()) {
            <ng-container *ngTemplateOutlet="simpleNav; context: { item: digestatNavItem }" />
          }
        }

        <!-- ═══════════ Exploitation - Pilotage ═══════════ -->
        @if (pilotageVisible() && (visiblePilotageHeadNavItems().length || visiblePilotageNavItems().length || rationProductionVisible())) {
          @if (!collapsed) {
            <li class="sidebar__section-caption">{{ 'nav_section_pilotage' | i18n }}</li>
          }
          @for (item of visiblePilotageHeadNavItems(); track item.route) {
            <ng-container *ngTemplateOutlet="simpleNav; context: { item }" />
          }
          @if (rationProductionVisible()) {
            <li
              class="sidebar__item sidebar__item--group"
              [class.sidebar__item--active]="rationProductionActive()"
            >
              <a
                [tabindex]="0"
                class="sidebar__link sidebar__link--group"
                (click)="onClickRationProduction()"
                (keydown.enter)="onClickRationProduction()"
              >
                <mat-icon class="sidebar__icon">{{ rationProductionGroup.icon }}</mat-icon>
                <span class="sidebar__label">{{ rationProductionGroup.label | i18n }}</span>
                @if (!collapsed) {
                  <mat-icon class="sidebar__chevron">
                    {{ rationProductionExpanded() ? 'expand_less' : 'expand_more' }}
                  </mat-icon>
                }
              </a>
              @if (rationProductionExpanded() && !collapsed) {
                <div class="sidebar__children">
                  @for (child of rationProductionGroup.children; track child.route) {
                    @if (isChildVisible(child)) {
                      <div
                        class="sidebar__child"
                        [class.sidebar__child--active]="isChildActive(child)"
                        [tabindex]="0"
                        (click)="navigateToChild(child, $event)"
                        (auxclick)="navigateToChild(child, $event)"
                        (keydown.enter)="navigateToChild(child)"
                      >
                        <span class="dot"></span>
                        <span class="label">{{ child.label | i18n }}</span>
                      </div>
                    }
                  }
                </div>
              }
            </li>
          }
          @for (item of visiblePilotageNavItems(); track item.route) {
            @if (item.children) {
              <li class="sidebar__item sidebar__item--group" [class.disabled]="isNavItemDisabled(item)">
                <a
                  [tabindex]="0"
                  class="sidebar__link sidebar__link--group"
                  (click)="togglePilotageGroup(item)"
                  (keydown.enter)="togglePilotageGroup(item)"
                >
                  <mat-icon class="sidebar__icon">{{ item.icon }}</mat-icon>
                  <span class="sidebar__label">{{ item.label | i18n }}</span>
                  @if (!collapsed) {
                    <mat-icon class="sidebar__chevron">
                      {{ isPilotageGroupExpanded(item) ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  }
                </a>
                @if (isPilotageGroupExpanded(item) && !collapsed) {
                  <div class="sidebar__children">
                    @for (child of item.children; track child.route) {
                      @if (isChildVisible(child)) {
                        <div
                          class="sidebar__child"
                          [class.sidebar__child--active]="isChildActive(child)"
                          [tabindex]="0"
                          (click)="navigateToChild(child, $event)"
                          (auxclick)="navigateToChild(child, $event)"
                          (keydown.enter)="navigateToChild(child)"
                        >
                          <span class="dot"></span>
                          <span class="label">{{ child.label | i18n }}</span>
                        </div>
                      }
                    }
                  </div>
                }
              </li>
            } @else {
              <ng-container *ngTemplateOutlet="simpleNav; context: { item }" />
            }
          }
        }

        <!-- ═══════════ Tableaux de bord – Opérations ═══════════ -->
        <!-- The static boards, above the personal dashboards (sidebar V2, ADEV-1046). -->
        @if (operationsSiteVisible()) {
          @if (!collapsed) {
            <li class="sidebar__section-caption">{{ 'nav_section_dashboards_operations' | i18n }}</li>
          }
          @for (item of visibleOperationsBoards(); track item.route) {
            <li
              class="sidebar__item"
              [class.sidebar__item--active]="isOperationsBoardActive(item)"
              [class.disabled]="isNavItemDisabled(item)"
            >
              <a
                [tabindex]="isNavItemDisabled(item) ? -1 : 0"
                class="sidebar__link"
                (click)="navigateTo(item, undefined, $event)"
                (auxclick)="navigateTo(item, undefined, $event)"
                (keydown.enter)="navigateTo(item)"
              >
                <mat-icon class="sidebar__icon">{{ item.icon }}</mat-icon>
                <span class="sidebar__label">{{ item.label | i18n }}</span>
              </a>
            </li>
          }
        }

        <!-- ═══════════ Tableaux de bord – Personnels ═══════════ -->
        @if (canViewDashboards()) {
          @if (!collapsed) {
            <li class="sidebar__section-caption">{{ 'nav_section_dashboards_personal' | i18n }}</li>
          }
          <li
            #dashboardsSection
            class="sidebar__item sidebar__item--group"
            [class.sidebar__item--active]="dashboardSectionActive()"
            [class.disabled]="!projectService.currentProject()"
          >
            <a
              [tabindex]="0"
              class="sidebar__link sidebar__link--group"
              (click)="toggleDashboardsSection()"
              (keydown.enter)="toggleDashboardsSection()"
              [matTooltip]="!projectService.currentProject() ? ('no_project_selected_tooltip' | i18n) : ''"
              matTooltipPosition="right"
            >
              <mat-icon class="sidebar__icon">dashboard</mat-icon>
              <span class="sidebar__label">{{ 'dashboards' | i18n }}</span>
              @if (!collapsed) {
                <mat-icon class="sidebar__chevron">
                  {{ dashboardsExpanded() ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              }
            </a>

            @if (dashboardsExpanded() && !collapsed) {
              <!-- Visible Dashboards -->
              <div
                class="flex-column"
                cdkDropList
                [cdkDropListData]="visibleDashboards()"
                [cdkDropListSortingDisabled]="!dashboardSectionActive()"
                (cdkDropListDropped)="onDashboardDrop($event)"
              >
                @for (dashboard of visibleDashboards(); track dashboard.id) {
                  <div
                    class="dashboard-item"
                    [tabindex]="0"
                    cdkDrag
                    [cdkDragDisabled]="!dashboardSectionActive()"
                    (click)="openDashboard(dashboard.id, dashboard.name, $event)"
                    (auxclick)="openDashboard(dashboard.id, dashboard.name, $event)"
                    (keydown.enter)="openDashboard(dashboard.id)"
                    [class.active]="dashboard.id === activeSubroute"
                  >
                    <span class="dot"></span>
                    <span class="label">{{ dashboard.name }}</span>
                    <mat-icon
                      class="dashboard-item__action"
                      [matTooltip]="'action_hide_dashboard' | i18n"
                      (click)="hideDashboard($event, dashboard.id)"
                    >visibility_off</mat-icon>
                  </div>
                }

                @if (canEditDashboards()) {
                  <div class="dashboard-item add" [tabindex]="0" (keydown.enter)="addDashboard()" (click)="addDashboard()">
                    <span class="plus">+</span>
                  </div>
                }
              </div>

              <!-- Hidden Dashboards -->
              @if (hiddenDashboards().length > 0) {
                <div class="dashboard-subgroup">
                  <a class="dashboard-subgroup__header" [tabindex]="0" (click)="toggleHiddenDashboardsGroup()" (keydown.enter)="toggleHiddenDashboardsGroup()">
                    <mat-icon class="sidebar__chevron">{{ hiddenDashboardsExpanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
                    <span class="label">{{ 'nav_hidden_dashboards' | i18n }} ({{ hiddenDashboards().length }})</span>
                  </a>
                  @if (hiddenDashboardsExpanded()) {
                    @for (dashboard of hiddenDashboards(); track dashboard.id) {
                      <div
                        class="dashboard-item dashboard-item--muted"
                        [tabindex]="0"
                        (click)="openDashboard(dashboard.id, dashboard.name, $event)"
                        (auxclick)="openDashboard(dashboard.id, dashboard.name, $event)"
                        (keydown.enter)="openDashboard(dashboard.id)"
                        [class.active]="dashboard.id === activeSubroute"
                      >
                        <span class="dot"></span>
                        <span class="label">{{ dashboard.name }}</span>
                        <mat-icon
                          class="dashboard-item__action"
                          [matTooltip]="'action_unhide_dashboard' | i18n"
                          (click)="unhideDashboard($event, dashboard.id)"
                        >visibility</mat-icon>
                      </div>
                    }
                  }
                </div>
              }

              <!-- All Dashboards -->
              @if (canBrowseAllDashboards()) {
                <div class="dashboard-subgroup">
                  <a
                    class="dashboard-subgroup__header"
                    [tabindex]="0"
                    (click)="toggleAllDashboards()"
                    (keydown.enter)="toggleAllDashboards()"
                  >
                    <mat-icon class="sidebar__chevron">
                      {{ allDashboardsExpanded() ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                    <span class="label">{{ 'nav_all_dashboards' | i18n }}</span>
                  </a>
                  @if (allDashboardsExpanded()) {
                    @for (dashboard of allDashboards(); track dashboard.id) {
                      <div
                        class="dashboard-item dashboard-item--muted"
                        [tabindex]="0"
                        (click)="openDashboard(dashboard.id, dashboard.name, $event)"
                        (auxclick)="openDashboard(dashboard.id, dashboard.name, $event)"
                        (keydown.enter)="openDashboard(dashboard.id)"
                        [class.active]="dashboard.id === activeSubroute"
                      >
                        <span class="dot"></span>
                        <span class="label">{{ dashboard.name }}</span>
                      </div>
                    }
                  }
                </div>
              }
            }
          </li>
        }

        <!-- ═══════════ Reporting ═══════════ -->
        @if (reportsNavItem && canViewReports()) {
          @if (!collapsed) {
            <li class="sidebar__section-caption">{{ 'nav_section_reporting' | i18n }}</li>
          }
          <li
            #reportsSection
            class="sidebar__item sidebar__item--group"
            [class.sidebar__item--active]="reportsNavItem.route === activeRoute()"
            [class.disabled]="isNavItemDisabled(reportsNavItem)"
          >
            <a
              [tabindex]="0"
              class="sidebar__link sidebar__link--group"
              (click)="toggleReportsSection()"
              (keydown.enter)="toggleReportsSection()"
            >
              <mat-icon class="sidebar__icon">{{ reportsNavItem.icon }}</mat-icon>
              <span class="sidebar__label">{{ reportsNavItem.label | i18n }}</span>
              @if (!collapsed) {
                <mat-icon class="sidebar__chevron">
                  {{ reportsExpanded() ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              }
            </a>

            @if (reportsExpanded() && !collapsed) {
              <!-- Visible Reports -->
              <div class="flex-column">
                @for (report of visibleReports(); track report.id) {
                  <div
                    class="dashboard-item"
                    [tabindex]="0"
                    (click)="navigateTo(reportsNavItem, report.id, $event)"
                    (auxclick)="navigateTo(reportsNavItem, report.id, $event)"
                    (keydown.enter)="navigateTo(reportsNavItem, report.id)"
                    [class.active]="report.id === activeSubroute"
                  >
                    <span class="dot"></span>
                    <span class="label">{{ report.name }}</span>
                    <mat-icon
                      class="dashboard-item__action"
                      [matTooltip]="'action_hide_report' | i18n"
                      (click)="hideReport($event, report.id)"
                      (keydown.enter)="hideReport($event, report.id)"
                    >
                      visibility_off
                    </mat-icon>
                  </div>
                }
                @if (reportsNavItem.route === activeRoute() && canEditReports()) {
                  <div class="dashboard-item add" [tabindex]="0" (keydown.enter)="addReport()" (click)="addReport()">
                    <span class="plus">+</span>
                  </div>
                }
              </div>

              <!-- Hidden Reports -->
              @if (hiddenReports().length > 0) {
                <div class="dashboard-subgroup">
                  <a
                    class="dashboard-subgroup__header"
                    [tabindex]="0"
                    (click)="toggleHiddenReportsGroup()"
                    (keydown.enter)="toggleHiddenReportsGroup()"
                  >
                    <mat-icon class="sidebar__chevron">
                      {{ hiddenReportsExpanded() ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                    <span class="label">{{ 'nav_hidden_reports' | i18n }} ({{ hiddenReports().length }})</span>
                  </a>
                  @if (hiddenReportsExpanded()) {
                    @for (report of hiddenReports(); track report.id) {
                      <div
                        class="dashboard-item dashboard-item--muted"
                        [tabindex]="0"
                        (click)="navigateTo(reportsNavItem, report.id, $event)"
                        (auxclick)="navigateTo(reportsNavItem, report.id, $event)"
                        (keydown.enter)="navigateTo(reportsNavItem, report.id)"
                        [class.active]="report.id === activeSubroute"
                      >
                        <span class="dot"></span>
                        <span class="label">{{ report.name }}</span>
                        <mat-icon
                          class="dashboard-item__action"
                          [matTooltip]="'action_unhide_report' | i18n"
                          (click)="unhideReport($event, report.id)"
                          (keydown.enter)="unhideReport($event, report.id)"
                        >
                          visibility
                        </mat-icon>
                      </div>
                    }
                  }
                </div>
              }

              <!-- All Reports -->
              @if (canBrowseAllReports()) {
                <div class="dashboard-subgroup">
                  <a
                    class="dashboard-subgroup__header"
                    [tabindex]="0"
                    (click)="toggleAllReports()"
                    (keydown.enter)="toggleAllReports()"
                  >
                    <mat-icon class="sidebar__chevron">
                      {{ allReportsExpanded() ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                    <span class="label">{{ 'nav_all_reports' | i18n }}</span>
                  </a>
                  @if (allReportsExpanded()) {
                    @for (report of allReports(); track report.id) {
                      <div
                        class="dashboard-item dashboard-item--muted"
                        [tabindex]="0"
                        (click)="navigateTo(reportsNavItem, report.id, $event)"
                        (auxclick)="navigateTo(reportsNavItem, report.id, $event)"
                        (keydown.enter)="navigateTo(reportsNavItem, report.id)"
                        [class.active]="report.id === activeSubroute"
                      >
                        <span class="dot"></span>
                        <span class="label">{{ report.name }}</span>
                      </div>
                    }
                  }
                </div>
              }
            }
          </li>
        }

        <!-- ═══════════ Réglementaire & Conformité ═══════════ -->
        @if (redVisible() || (flareNavItem && canViewFlare())) {
          @if (!collapsed) {
            <li class="sidebar__section-caption">{{ 'nav_section_reglementaire' | i18n }}</li>
          }
          @if (redVisible()) {
            <ng-container *ngTemplateOutlet="simpleNav; context: { item: redNavItem }" />
          }
          @if (flareNavItem && canViewFlare()) {
            <ng-container *ngTemplateOutlet="simpleNav; context: { item: flareNavItem }" />
          }
        }

        <!-- ═══════════ Configuration ═══════════ -->
        @if (configurationVisible() && !collapsed) {
          <li class="sidebar__section-caption">{{ 'nav_section_configuration' | i18n }}</li>
        }

        @if (parametrageVisible()) {
          <li class="sidebar__item sidebar__item--group">
            <a
              [tabindex]="0"
              class="sidebar__link sidebar__link--group"
              (click)="onClickConfiguration()"
              (keydown.enter)="onClickConfiguration()"
            >
              <mat-icon class="sidebar__icon">{{ parametrageGroup.icon }}</mat-icon>
              <span class="sidebar__label">{{ parametrageGroup.label | i18n }}</span>
              @if (!collapsed) {
                <mat-icon class="sidebar__chevron">
                  {{ parametrageExpanded() ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              }
            </a>
            @if (parametrageExpanded() && !collapsed) {
              <div class="sidebar__children">
                @for (child of parametrageGroup.children; track child.route) {
                  @if (child.disabled) {
                    @if (isChildVisible(child)) {
                      <div class="sidebar__child sidebar__child--purple disabled" [tabindex]="-1">
                        <span class="dot"></span>
                        <span class="label">{{ child.label | i18n }}</span>
                      </div>
                    }
                  } @else if (isChildVisible(child)) {
                    <div
                      class="sidebar__child sidebar__child--purple"
                      [class.sidebar__child--active-purple]="isChildActive(child)"
                      [tabindex]="0"
                      (click)="navigateToChild(child, $event)"
                      (auxclick)="navigateToChild(child, $event)"
                      (keydown.enter)="navigateToChild(child)"
                    >
                      <span class="dot"></span>
                      <span class="label">{{ child.label | i18n }}</span>
                    </div>
                  }
                }
              </div>
            }
          </li>
        }

        <!-- Données Site: Gisements + the producer / supplier / transporter
             reference pages (sidebar V2, ADEV-1046). -->
        @if (intrantsDbVisible()) {
          <li class="sidebar__item sidebar__item--group">
            <a
              [tabindex]="0"
              class="sidebar__link sidebar__link--group"
              (click)="onClickIntrantsDb()"
              (keydown.enter)="onClickIntrantsDb()"
            >
              <mat-icon class="sidebar__icon">{{ intrantsDbGroup.icon }}</mat-icon>
              <span class="sidebar__label">{{ intrantsDbGroup.label | i18n }}</span>
              @if (!collapsed) {
                <mat-icon class="sidebar__chevron">
                  {{ intrantsDbExpanded() ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              }
            </a>
            @if (intrantsDbExpanded() && !collapsed) {
              <div class="sidebar__children">
                @for (child of intrantsDbDirectLinks(); track child.route) {
                  @if (isChildVisible(child)) {
                    <div
                      class="sidebar__child sidebar__child--purple"
                      [class.sidebar__child--active-purple]="isChildActive(child)"
                      [tabindex]="0"
                      (click)="navigateToChild(child, $event)"
                      (auxclick)="navigateToChild(child, $event)"
                      (keydown.enter)="navigateToChild(child)"
                    >
                      <span class="dot"></span>
                      <span class="label">{{ child.label | i18n }}</span>
                    </div>
                  }
                }
              </div>
            }
          </li>
        }

        <!-- Données entrantes: the MotherDB browser (views, the Energie folder,
             per-system sources), BDD Intrants and the sync status. -->
        @if (donneesEntrantesVisible()) {
          <li class="sidebar__item sidebar__item--group">
            <a
              [tabindex]="0"
              class="sidebar__link sidebar__link--group"
              (click)="onClickDonneesEntrantes()"
              (keydown.enter)="onClickDonneesEntrantes()"
            >
              <mat-icon class="sidebar__icon">{{ donneesEntrantesGroup.icon }}</mat-icon>
              <span class="sidebar__label">{{ donneesEntrantesGroup.label | i18n }}</span>
              @if (!collapsed) {
                <mat-icon class="sidebar__chevron">
                  {{ donneesEntrantesExpanded() ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              }
            </a>
            @if (donneesEntrantesExpanded() && !collapsed) {
              <div class="sidebar__children">
                @for (child of motherdbViews(); track child.route) {
                  <div
                    class="sidebar__child sidebar__child--purple"
                    [class.sidebar__child--active-purple]="isChildActive(child)"
                    [tabindex]="0"
                    (click)="navigateToChild(child, $event)"
                    (auxclick)="navigateToChild(child, $event)"
                    (keydown.enter)="navigateToChild(child)"
                  >
                    <span class="dot"></span>
                    <span class="label">{{ child.label | i18n }}</span>
                  </div>
                }

                <!-- The energy views, in their own folder (CVES-12) -->
                @if (motherdbEnergieViews().length) {
                  <div
                    class="sidebar__subgroup-header"
                    [tabindex]="0"
                    (click)="energieExpanded.set(!energieExpanded())"
                    (keydown.enter)="energieExpanded.set(!energieExpanded())"
                  >
                    <span class="label">{{ 'nav_energie' | i18n }}</span>
                    <mat-icon class="sidebar__chevron">
                      {{ energieExpanded() ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  </div>
                  @if (energieExpanded()) {
                    @for (child of motherdbEnergieViews(); track child.route) {
                      <div
                        class="sidebar__child sidebar__child--purple sidebar__child--nested"
                        [class.sidebar__child--active-purple]="isChildActive(child)"
                        [tabindex]="0"
                        (click)="navigateToChild(child, $event)"
                        (auxclick)="navigateToChild(child, $event)"
                        (keydown.enter)="navigateToChild(child)"
                      >
                        <span class="dot"></span>
                        <span class="label">{{ child.label | i18n }}</span>
                      </div>
                    }
                  }
                }

                <!-- Per-system source collections (Wintrans, Ecovalim, …), each a dropdown -->
                @for (grp of motherdbReferenceGroups(); track grp.group) {
                  <div
                    class="sidebar__subgroup-header"
                    [tabindex]="0"
                    (click)="toggleRefGroup(grp.group)"
                    (keydown.enter)="toggleRefGroup(grp.group)"
                  >
                    <span class="label">{{ grp.group }}</span>
                    <mat-icon class="sidebar__chevron">
                      {{ isRefGroupExpanded(grp.group) ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  </div>
                  @if (isRefGroupExpanded(grp.group)) {
                    @for (child of grp.items; track child.route) {
                      <div
                        class="sidebar__child sidebar__child--purple sidebar__child--nested"
                        [class.sidebar__child--active-purple]="isChildActive(child)"
                        [tabindex]="0"
                        (click)="navigateToChild(child, $event)"
                        (auxclick)="navigateToChild(child, $event)"
                        (keydown.enter)="navigateToChild(child)"
                      >
                        <span class="dot"></span>
                        <span class="label">{{ child.label | i18n }}</span>
                      </div>
                    }
                  }
                }

                <div
                  class="sidebar__child sidebar__child--purple"
                  [class.sidebar__child--active-purple]="isChildActive(bddIntrantsLink)"
                  [tabindex]="0"
                  (click)="navigateToChild(bddIntrantsLink, $event)"
                  (auxclick)="navigateToChild(bddIntrantsLink, $event)"
                  (keydown.enter)="navigateToChild(bddIntrantsLink)"
                >
                  <span class="dot"></span>
                  <span class="label">{{ bddIntrantsLink.label | i18n }}</span>
                </div>

                <div
                  class="sidebar__child sidebar__child--purple"
                  [class.sidebar__child--active-purple]="isChildActive(motherdbSyncStatus)"
                  [tabindex]="0"
                  (click)="navigateToChild(motherdbSyncStatus, $event)"
                  (auxclick)="navigateToChild(motherdbSyncStatus, $event)"
                  (keydown.enter)="navigateToChild(motherdbSyncStatus)"
                  *appHasPermission="motherdbSyncStatus.permission ?? ''"
                >
                  <span class="dot"></span>
                  <span class="label">{{ motherdbSyncStatus.label | i18n }}</span>
                </div>
              </div>
            }
          </li>
        }

        <!-- Données sortantes: what Anessa sends out; today « Fichiers pont bascule »,
             the weighbridge reference files (ADEV-1207). -->
        @if (donneesSortantesVisible()) {
          <li class="sidebar__item sidebar__item--group">
            <a
              [tabindex]="0"
              class="sidebar__link sidebar__link--group"
              (click)="onClickDonneesSortantes()"
              (keydown.enter)="onClickDonneesSortantes()"
            >
              <mat-icon class="sidebar__icon">{{ donneesSortantesGroup.icon }}</mat-icon>
              <span class="sidebar__label">{{ donneesSortantesGroup.label | i18n }}</span>
              @if (!collapsed) {
                <mat-icon class="sidebar__chevron">
                  {{ donneesSortantesExpanded() ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              }
            </a>
            @if (donneesSortantesExpanded() && !collapsed) {
              <div class="sidebar__children">
                <div
                  class="sidebar__subgroup-header"
                  [tabindex]="0"
                  (click)="weighbridgeFilesExpanded.set(!weighbridgeFilesExpanded())"
                  (keydown.enter)="weighbridgeFilesExpanded.set(!weighbridgeFilesExpanded())"
                >
                  <span class="label">{{ 'nav_weighbridge_files' | i18n }}</span>
                  <mat-icon class="sidebar__chevron">
                    {{ weighbridgeFilesExpanded() ? 'expand_less' : 'expand_more' }}
                  </mat-icon>
                </div>
                @if (weighbridgeFilesExpanded()) {
                  @for (child of weighbridgeFiles; track child.route) {
                    <div
                      class="sidebar__child sidebar__child--purple sidebar__child--nested"
                      [class.sidebar__child--active-purple]="isChildActive(child)"
                      [tabindex]="0"
                      (click)="navigateToChild(child, $event)"
                      (auxclick)="navigateToChild(child, $event)"
                      (keydown.enter)="navigateToChild(child)"
                    >
                      <span class="dot"></span>
                      <span class="label">{{ child.label | i18n }}</span>
                    </div>
                  }
                }
              </div>
            }
          </li>
        }

        <!-- Mesures (Insights) -->
        @if (insightsNavItem && canViewInsights()) {
          <ng-container *ngTemplateOutlet="simpleNav; context: { item: insightsNavItem }" />
        }

        @if (configurationVisible() && isNavItemVisible(alarmesNavItem)) {
          <ng-container *ngTemplateOutlet="simpleNav; context: { item: alarmesNavItem }" />
        }

        @if (tableauxVisible()) {
        @if (!collapsed) {
          <li class="sidebar__section-caption">{{ 'nav_section_tableaux' | i18n }}</li>
        }
        <!-- Custom Views — opens the popout panel -->
        <ng-container *appHasSection="SECTIONS.CUSTOM_VIEWS">
        <li class="sidebar__item"
            [class.sidebar__item--active]="customViewsRouteActive()">
          <a
            [tabindex]="0"
            class="sidebar__link"
            (click)="customViewsPopoutToggle.emit()"
            (keydown.enter)="customViewsPopoutToggle.emit()"
          >
            <mat-icon class="sidebar__icon">table_rows</mat-icon>
            <span class="sidebar__label">{{ 'custom_views' | i18n }}</span>
          </a>
        </li>
        </ng-container>

        <!-- Data Management — opens the popout panel -->
        <ng-container *appHasSection="SECTIONS.TABLE_DATA">
        <li class="sidebar__item"
            [class.sidebar__item--active]="dataManagementRouteActive()">
          <a
            [tabindex]="0"
            class="sidebar__link"
            (click)="managedDataPopoutToggle.emit()"
            (keydown.enter)="managedDataPopoutToggle.emit()"
          >
            <mat-icon class="sidebar__icon">storage</mat-icon>
            <span class="sidebar__label">{{ 'data_management' | i18n }}</span>
          </a>
        </li>
        </ng-container>

        <!-- TimeSeries Data — opens the popout panel -->
        <ng-container *appHasSection="SECTIONS.TIMESERIES">
        <li class="sidebar__item"
            [class.sidebar__item--active]="timeseriesRouteActive()">
          <a
            [tabindex]="0"
            class="sidebar__link"
            (click)="timeseriesPopoutToggle.emit()"
            (keydown.enter)="timeseriesPopoutToggle.emit()"
          >
            <mat-icon class="sidebar__icon">{{ timeseriesDataGroup().icon }}</mat-icon>
            <span class="sidebar__label">{{ timeseriesDataGroup().label | i18n }}</span>
          </a>
        </li>
        </ng-container>
        }

        <!-- Weighbridge expandable group (hidden for now; import moved to Approvisionnements) -->
        @if (showWeighbridgeSection && !isMultiPlantProject()) {
        <ng-container *appHasPermission="Permissions.VIEW_WEIGHBRIDGE">
        <li class="sidebar__item sidebar__item--group sidebar__item--weighbridge-active">
          <a
            [tabindex]="0"
            class="sidebar__link sidebar__link--group"
            (click)="onClickWeighBridge()"
            (keydown.enter)="onClickWeighBridge()"
          >
            <span class="sidebar__icon material-symbols-outlined">scale</span>
            <span class="sidebar__label">{{ weighbridgeGroup.label | i18n }}</span>
            @if (!collapsed) {
              <mat-icon class="sidebar__chevron">
                {{ weighbridgeExpanded() ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            }
          </a>
          @if (weighbridgeExpanded() && !collapsed) {
            <div class="sidebar__children">
              @for (child of weighbridgeGroup.children; track child.route) {
                @if (child.permission) {
                  <div
                    class="sidebar__child sidebar__child--purple"
                    [class.sidebar__child--active-purple]="isChildActive(child)"
                    [tabindex]="0"
                    (click)="navigateToChild(child, $event)"
                    (auxclick)="navigateToChild(child, $event)"
                    (keydown.enter)="navigateToChild(child)"
                    *appHasPermission="child.permission"
                  >
                    <span class="dot"></span>
                    <span class="label">@if (child.isRawLabel) { {{ child.label }} } @else { {{ child.label | i18n }} }</span>
                  </div>
                } @else {
                  <div
                    class="sidebar__child sidebar__child--purple"
                    [class.sidebar__child--active-purple]="isChildActive(child)"
                    [tabindex]="0"
                    (click)="navigateToChild(child, $event)"
                    (auxclick)="navigateToChild(child, $event)"
                    (keydown.enter)="navigateToChild(child)"
                  >
                    <span class="dot"></span>
                    <span class="label">@if (child.isRawLabel) { {{ child.label }} } @else { {{ child.label | i18n }} }</span>
                  </div>
                }
              }
            </div>
          }
        </li>
        </ng-container>
        }
      </ul>
    </nav>
  </aside>
}
